import { __ } from '@wordpress/i18n'

export default {
  postsNotFound: __('Posts not found!', 'dhsv_theme'),
  postsNotFoundDe: __(
    'Aktuell haben wir keine verfügbaren Events, aber schauen Sie sich gerne unsere <a href="/akademie/">Online-Veranstaltungen</a> an.',
    'dhsv_theme'
  ),
  postsNotFoundCh: __(
    'Aktuell haben wir keine verfügbaren Events, aber schauen Sie sich gerne unsere <a href="/de-ch/akademie/">Online-Veranstaltungen</a> an.',
    'dhsv_theme'
  ),
  postsNotFoundIt: __(
    'Al momento non abbiamo eventi disponibili, ma vi invitiamo a dare un\'occhiata ai nostri <a href="/webinar-ondemand/">eventi online.</a>',
    'dhsv_theme'
  ),
}
